export const HeaderLinks: { title: string; titleAr: string; link: string; linkAr: string }[] = [
  {
    title: 'home',
    titleAr: 'الصفحة الرئيسية',
    link: 'https://tawal.com.sa/en/index',
    linkAr: 'https://tawal.com.sa/ar/index',
  },
  {
    title: 'about us',
    titleAr: 'نبذة عنا',
    link: 'https://tawal.com.sa/en/about-us',
    linkAr: 'https://tawal.com.sa/ar/about',
  },
  {
    title: 'our markets',
    titleAr: 'أسواقنا',
    link: 'https://tawal.com.sa/en/market',
    linkAr: 'https://tawal.com.sa/ar/market',
  },
  {
    title: 'solutions',
    titleAr: 'الحلول',
    link: 'https://tawal.com.sa/en/solutions',
    linkAr: 'https://tawal.com.sa/ar/solutions',
  },
  {
    title: 'sustainability',
    titleAr: 'استدامتنا',
    link: 'https://tawal.com.sa/en/sustainability',
    linkAr: 'https://tawal.com.sa/ar/sustainability',
  },
  {
    title: 'join our team',
    titleAr: 'انضم إلى فريقنا',
    link: 'https://tawal.com.sa/en/team',
    linkAr: 'https://tawal.com.sa/ar/team',
  },
  {
    title: 'media',
    titleAr: 'الأخبار',
    link: 'https://tawal.com.sa/en/media',
    linkAr: 'https://tawal.com.sa/ar/media',
  },
  {
    title: 'WHISTLEBLOWING',
    titleAr: 'الممارسات المخالفة',
    link: 'https://tawal.com.sa/en/whistleblower',
    linkAr: 'https://tawal.com.sa/ar/whistleblower',
  },
  {
    title: 'Platforms',
    titleAr: 'المنصات',
    link: 'https://www.tawal.com.sa/en/shurakaa',
    linkAr: 'https://tawal.com.sa/ar/shurakaa',
  },
  {
    title: 'contact us',
    titleAr: 'اتصل بنا',
    link: 'https://tawal.com.sa/en/contact-us',
    linkAr: 'https://tawal.com.sa/ar/contact-us',
  },
];
